import api from './api';

export interface AutomationRule {
  id: string;
  name: string;
  description?: string;
  triggerType: string;
  isActive: boolean;
  executionCount: number;
  lastExecutedAt?: string;
  createdAt: string;
}

export interface CreateAutomationRuleDto {
  name: string;
  description?: string;
  triggerType: string;
  triggerSettings?: string;
}

export interface AutomationExecutionLog {
  id: string;
  ruleId: string;
  ruleName: string;
  success: boolean;
  errorMessage?: string;
  executedAt: string;
}

// Get all automation rules
export const getAutomationRules = async (): Promise<AutomationRule[]> => {
  const response = await api.get<AutomationRule[]>('/automation/rules');
  return response.data;
};

// Get automation rule by ID
export const getAutomationRule = async (id: string): Promise<AutomationRule> => {
  const response = await api.get<AutomationRule>(`/automation/rules/${id}`);
  return response.data;
};

// Create automation rule
export const createAutomationRule = async (data: CreateAutomationRuleDto): Promise<AutomationRule> => {
  const response = await api.post<AutomationRule>('/automation/rules', data);
  return response.data;
};

// Toggle automation rule
export const toggleAutomationRule = async (id: string, isActive: boolean): Promise<AutomationRule> => {
  const response = await api.post<AutomationRule>(`/automation/rules/${id}/toggle`);
  return response.data;
};

// Delete automation rule
export const deleteAutomationRule = async (id: string): Promise<void> => {
  await api.delete(`/automation/rules/${id}`);
};

// Get execution logs
export const getExecutionLogs = async (ruleId?: string): Promise<AutomationExecutionLog[]> => {
  const url = ruleId ? `/automation/rules/${ruleId}/logs` : '/automation/logs';
  const response = await api.get<AutomationExecutionLog[]>(url);
  return response.data;
};
